<app-page-body>
  <!-- header -->
  <app-page-header
    *ngIf="!isDialogMode"
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">
      <!-- mobiles for create form-->
      <section class="tw-mb-2" *ngIf="!formPageConfig.isEditMode">
        <fieldset>
          <legend>
            {{ "common.mobiles" | translate }}
          </legend>

          <!--add new mobile field-->
          <div class="tw-m-10">
            <!--mobiles in create mode-->
            <div
              class="2xl:tw-grid-cols-5 xl:tw-grid-cols-4 lg:tw-grid-cols-3 sm:tw-grid-cols-2 tw-grid-cols-1 tw-gap-x-6 tw-gap-y-8 tw-grid"
            >
              <div *ngFor="let item of newMobiles; let i = index">
                <div class="tw-relative">
                  <!-- btns -->
                  <div
                    class="tw-absolute tw-left-[18px] tw-top-[-17px] tw-flex tw-items-center"
                  >
                    <!-- remove btn -->
                    <button
                      *ngIf="
                        userSession?.isSuperAdmin() ||
                        (newMobiles.length == 1 && !userSession?.isSuperAdmin())
                      "
                      [matTooltip]="'common.delete' | translate"
                      class="tw-flex-center btn tw-mr-[5px] ltr:tw-ml-[5px] btn-danger tw-rounded-full tw-w-10 tw-h-10 tw-z-[1]"
                      (click)="onRemoveMobile(i)"
                    >
                      <i class="mdi mdi-delete-outline mdi-20px"></i>
                    </button>
                  </div>

                  <div
                    class="dark:tw-bg-dark-100/80 rounded tw-bg-gray-100/90 tw-py-5 tw-w-full tw-h-48 tw-flex tw-justify-around tw-flex-col tw-px-7"
                  >
                    <!-- authenticated-->

                    <div
                      class="tw-my-5 dark:tw-text-gray-300 tw-w-full tw-flex-center"
                    >
                      <i
                        [matTooltip]="
                          'pages.systemManagement.users.userForm.notConfirmed'
                            | translate
                        "
                        class="mdi tw-ml-2 mdi-26px mdi-information tw-text-red-500 tw-animate-pulse tw-cursor-pointer"
                      ></i>

                      <!-- mobile -->
                      <span
                        class="tw-font-bold xl:tw-text-2xl tw-text-xl tw-mx-1 tw-text-primary-700 dark:tw-text-primary-200"
                      >
                        {{ item }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- add new mobile -->
              <div
                *ngIf="
                  userSession?.isSuperAdmin() ||
                  (newMobiles.length < 1 && !userSession?.isSuperAdmin())
                "
                (click)="onOpenAddUserMobileDialog()"
                [matTooltip]="'common.add' | translate"
                class="tw-border-2 tw-border-dashed dark:hover:tw-bg-dark-200 tw-border-primary-300 hover:tw-bg-primary-50 tw-h-48 tw-rounded-md tw-flex-center tw-cursor-pointer"
              >
                <i class="mdi mdi-plus mdi-40px tw-text-primary-300"></i>
              </div>
            </div>
          </div>
          <!-- <div class="tw-flex tw-flex-wrap">
            @for (mobile of newMobiles; track $index; let last = $last) {
            <div class="lg:tw-w-1/3 md:tw-w-1/2 tw-px-2 xl:tw-w-1/4">
              <app-user-mobiles
                [isEdit]="formPageConfig?.isEditMode"
                [model]="newMobiles[$index]"
                [index]="$index"
                [showDeleteOptionBtn]="newMobiles.length > 1"
                [showAddOptionBtn]="last"
                (mobile)="newMobiles[$index] = $event"
                (removeMobile)="onRemoveMobile($event)"
                (form)="mobilesForm[$index] = $event"
                (addOption)="onAddMobile()"
              >
              </app-user-mobiles>
            </div>
            }
          </div> -->
        </fieldset>
      </section>
      <!-- authentication in edit form -->
      <section class="tw-mb-2" *ngIf="formPageConfig.isEditMode">
        <fieldset>
          <legend>
            {{ pageVocabs + "legends.authentication" | translate }}
          </legend>

          <!--add new mobile field-->
          <div class="tw-m-10">
            <!--mobiles in edit mode-->
            <div
              class="2xl:tw-grid-cols-5 xl:tw-grid-cols-4 lg:tw-grid-cols-3 sm:tw-grid-cols-2 tw-grid-cols-1 tw-gap-x-6 tw-gap-y-8 tw-grid"
            >
              <div *ngFor="let item of model.mobile">
                @if(item?.mobile){
                <div class="tw-relative">
                  <!-- btns -->
                  <div
                    class="tw-absolute tw-left-[18px] tw-top-[-17px] tw-flex tw-items-center"
                  >
                    <!-- edit btn -->
                    <button
                      [matTooltip]="
                        'pages.systemManagement.users.userForm.changeNumber'
                          | translate
                      "
                      class="tw-flex-center btn tw-mr-[5px] ltr:tw-ml-[5px] btn-blue tw-rounded-full tw-w-10 tw-h-10 tw-z-[1]"
                      (click)="openUpdateMobileForm(item)"
                    >
                      <i class="mdi mdi-pencil-outline mdi-20px"></i>
                    </button>

                    <!-- remove btn -->
                    <button
                      *ngIf="
                        userSession?.isSuperAdmin() ||
                        (newMobiles.length == 1 && !userSession?.isSuperAdmin())
                      "
                      [matTooltip]="'common.delete' | translate"
                      class="tw-flex-center btn tw-mr-[5px] ltr:tw-ml-[5px] btn-danger tw-rounded-full tw-w-10 tw-h-10 tw-z-[1]"
                      (click)="onAddOrDeleteMobile(item)"
                    >
                      <i class="mdi mdi-delete-outline mdi-20px"></i>
                    </button>
                  </div>

                  <div
                    class="dark:tw-bg-dark-100/80 rounded tw-bg-gray-100/90 tw-py-5 tw-w-full tw-h-48 tw-flex tw-justify-around tw-flex-col tw-px-7"
                  >
                    <!-- authenticated-->

                    <div
                      class="tw-my-5 dark:tw-text-gray-300 tw-w-full tw-flex-center"
                    >
                      @if(!item.isAuthenticated){
                      <i
                        [matTooltip]="
                          'pages.systemManagement.users.userForm.notConfirmed'
                            | translate
                        "
                        class="mdi tw-ml-2 mdi-26px mdi-information tw-text-red-500 tw-animate-pulse tw-cursor-pointer"
                      ></i>
                      }

                      <!-- mobile -->
                      <span
                        class="tw-font-bold xl:tw-text-2xl tw-text-xl tw-mx-1 tw-text-primary-700 dark:tw-text-primary-200"
                      >
                        {{ item.mobile }}
                      </span>
                    </div>

                    <!-- Authenticated mobile btn -->
                    <div class="tw-mb-2">
                      @if(!item.isAuthenticated){
                      <button
                        [themeColor]="'ring-btn-gradient'"
                        (click)="openMobileAuthenticationForm(item)"
                        class="tw-w-full tw-font-bold tw-border btn btn-primary tw-text-center tw-cursor-pointer tw-p-4"
                        style="height: 45px !important"
                      >
                        <i
                          class="mdi tw-ml-2 mdi-22px mdi-cellphone tw-text-white"
                        ></i>

                        <span>
                          {{ "common.isAuthenticatedMobile" | translate }}
                        </span>
                      </button>
                      } @else {
                      <div
                        (click)="openMobileAuthenticationForm(item)"
                        class="tw-w-full tw-h-[45px] tw-font-bold tw-border tw-flex-center tw-bg-teal-100/40 dark:tw-bg-teal-950/30 tw-border-teal-500/50 tw-text-teal-600 tw-text-center tw-p-4 tw-rounded-lg"
                      >
                        <i
                          class="mdi tw-ml-2 mdi-22px mdi-check-circle-outline tw-text-teal-600"
                        ></i>

                        <span>
                          {{ "common.isConfirmed" | translate }}
                        </span>
                      </div>
                      }
                    </div>
                  </div>
                </div>
                }
              </div>

              <!-- add new mobile -->
              <div
                *ngIf="
                  userSession?.isSuperAdmin() ||
                  (newMobiles.length < 1 && !userSession?.isSuperAdmin())
                "
                (click)="onOpenAddUserMobileDialog()"
                [matTooltip]="'common.add' | translate"
                class="tw-border-2 tw-border-dashed dark:hover:tw-bg-dark-200 tw-border-primary-300 hover:tw-bg-primary-50 tw-h-48 tw-rounded-md tw-flex-center tw-cursor-pointer"
              >
                <i class="mdi mdi-plus mdi-40px tw-text-primary-300"></i>
              </div>
            </div>

            <!-- twoFactorEnabled -->
            <div class="md:tw-w-full lg:tw-w-1/3">
              <div class="checkbox-section tw-mt-5 tw-ml-2">
                <!-- [disabled]="!isMobileAuthenticated" -->
                <mat-slide-toggle
                  formControlName="twoFactorEnabled"
                  [(ngModel)]="twoFactorEnabled"
                >
                  {{ "common.twoFactorEnabled" | translate }}</mat-slide-toggle
                >
              </div>
            </div>
          </div>
        </fieldset>
      </section>

      <!-- personal Information -->
      <section class="tw-mb-2">
        <fieldset>
          <legend>
            {{ pageVocabs + "legends.personalInformation" | translate }}
          </legend>

          <div class="row">
            <!-- isForeigner -->
            <div class="tw-w-full">
              <div class="checkbox-section tw-mt-4 tw-ml-2">
                <mat-slide-toggle
                  formControlName="isForeigner"
                  [(ngModel)]="model.isForeigner"
                  (change)="changePersonalInformationValidators()"
                >
                  {{ "common.isForeigner" | translate }}</mat-slide-toggle
                >
              </div>
            </div>
          </div>

          <div class="row">
            <!-- firstName -->
            <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
              <form-field
                [(value)]="model.firstName"
                [control]="form?.get('firstName')"
                label="common.firstName"
                [maxLength]="32"
              >
              </form-field>
            </div>

            <!-- lastName -->
            <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
              <form-field
                [(value)]="model.lastName"
                [control]="form?.get('lastName')"
                label="common.lastName"
                [maxLength]="32"
              >
              </form-field>
            </div>

            <!-- fatherName -->
            <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
              <form-field
                [(value)]="model.fatherName"
                [control]="form?.get('fatherName')"
                label="common.fatherName"
                [maxLength]="32"
              >
              </form-field>
            </div>

            <!-- birthDate -->
            <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
              <datepicker
                [value]="model.birthDate"
                (value)="model.birthDate = $event"
                [control]="form?.get('birthDate')"
                label="common.birthDate"
                (onErrorDatePicker)="showErrorDialog($event)"
              >
              </datepicker>
            </div>

            <!-- nationalCode -->
            <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
              <form-field
                [(value)]="model.nationalCode"
                [control]="form?.get('nationalCode')"
                [label]="
                  !model.isForeigner
                    ? 'common.nationalCode'
                    : (fields + 'foreignerCode' | translate)
                "
                [minLength]="model.isForeigner ? 12 : 10"
                [maxLength]="model.isForeigner ? 12 : 10"
                type="tel"
              >
              </form-field>
            </div>

            <!-- identityNumber -->
            <div
              class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4"
              *ngIf="!model.isForeigner"
            >
              <form-field
                [(value)]="model.identityNumber"
                [control]="form?.get('identityNumber')"
                label="common.identityNumber"
                [minLength]="1"
                [maxLength]="10"
                type="tel"
                readonly="formPageConfig.isEdit"
              >
              </form-field>
            </div>

            <!-- phone -->
            <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
              <form-field
                [(value)]="model.phone"
                [control]="form?.get('phone')"
                label="common.phone"
                type="tel"
                [maxLength]="11"
              >
              </form-field>
            </div>

            <!-- faxNumber -->
            <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
              <form-field
                [(value)]="model.faxNumber"
                [control]="form?.get('faxNumber')"
                label="common.faxNumber"
                type="tel"
                [maxLength]="11"
              >
              </form-field>
            </div>

            <!-- country -->
            <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
              <zones-select-search
                label="common.country"
                class="tw-w-full"
                type="byZoneType"
                [zoneType]="ZoneType.Country"
                [control]="form?.get('country')"
                [value]="selectedCountry"
                (valueChange)="onChangeZones($event, 'states')"
                (onError)="onClose()"
              >
              </zones-select-search>
            </div>

            <!-- state -->
            <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
              <zones-select-search
                label="common.state"
                class="tw-w-full"
                [control]="form?.get('state')"
                [id]="selectedCountry"
                [value]="selectedState"
                (valueChange)="onChangeZones($event, 'cities')"
                (onError)="onClose()"
              >
              </zones-select-search>
            </div>

            <!--city(zoneId) -->
            <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
              <zones-select-search
                label="common.city"
                class="tw-w-full"
                [id]="selectedState"
                [control]="form?.get('zoneId')"
                [value]="selectedState ? model.zoneId : null"
                (valueChange)="selectedState ? (model.zoneId = $event) : ''"
                (onError)="onClose()"
              >
              </zones-select-search>
            </div>

            <!-- zipCode -->
            <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
              <form-field
                [(value)]="model.zipCode"
                [control]="form?.get('zipCode')"
                label="common.zipCode"
                type="tel"
                [maxLength]="10"
                [minLength]="10"
              >
              </form-field>
            </div>

            <!-- address -->
            <div class="md:tw-w-1/2">
              <form-textarea
                class="tw-w-full"
                label="common.address"
                [(value)]="model.address"
                [control]="form?.get('address')"
                [rows]="1"
              >
              </form-textarea>
            </div>

            <!-- password & confirm password -->
            <div class="lg:tw-w-2/3 xl:tw-w-1/2">
              <app-set-password
                class="tw-w-full"
                responsiveClass="md:tw-w-1/2"
                [isRequired]="formPageConfig.isEditMode ? false : true"
                [isRefreshForm]="isRefreshForm"
                (isRefreshForm)="isRefreshForm = $event"
                (password)="model.password = $event"
                (form)="passwordForm = $event"
              >
              </app-set-password>
            </div>
          </div>
        </fieldset>
      </section>

      <!-- system Information -->
      <section class="tw-mb-2">
        <fieldset>
          <legend>
            {{ pageVocabs + "legends.systemInformation" | translate }}
          </legend>

          <div class="row">
            <!-- userName -->
            <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
              <form-field
                [(value)]="model.userName"
                [control]="form?.get('userName')"
                label="common.userName"
                [maxLength]="32"
              >
              </form-field>
            </div>

            <!-- email -->
            <div class="md:tw-w-1/2 lg:tw-w-1/3 xl:tw-w-1/4">
              <form-field
                [(value)]="model.email"
                [control]="form?.get('email')"
                label="common.email"
              >
              </form-field>
            </div>

            <ng-container>
              <!-- organizationId -->
              <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
                <organization-select-search
                  *ngIf="isEnableSystemInfo()"
                  class="tw-w-full"
                  [type]="
                    userType == 'reseller'
                      ? 'currentResellerOrganization'
                      : 'organizationForCreateUser'
                  "
                  [control]="form?.get('organizationId')"
                  [(value)]="model.organizationId"
                  (onError)="onClose()"
                >
                </organization-select-search>
                <form-field
                  *ngIf="!isEnableSystemInfo()"
                  [value]="this.formPageConfig.editData.organizationName"
                  (valueChange)="(model.organizationId)"
                  [control]="form?.get('organizationId')"
                  label="common.organization"
                >
                </form-field>
              </div>

              <!-- expireDate -->
              <div class="sm:tw-w-1/2 md:tw-w-2/3 xl:tw-w-1/2">
                <app-date-time-picker
                  [config]="dateTimeConfig"
                  (dateTime)="model.expireDate = $event"
                >
                </app-date-time-picker>
              </div>

              <!-- descriptions -->
              <div class="md:tw-w-2/3 xl:tw-w-3/4">
                <form-textarea
                  class="tw-w-full"
                  label="common.description"
                  [(value)]="model.descriptions"
                  [control]="form?.get('description')"
                  [rows]="4"
                >
                </form-textarea>
              </div>

              <!-- checkBoxes  -->
              <div class="tw-flex tw-flex-wrap">
                <!-- isActiveSend -->
                <div
                  class="checkbox-section sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4"
                >
                  <mat-slide-toggle
                    formControlName="isActiveSend"
                    [(ngModel)]="model.isActiveSend"
                  >
                    {{ "common.isActiveSend" | translate }}</mat-slide-toggle
                  >
                </div>

                <!-- isActive -->
                <div
                  class="checkbox-section sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4"
                >
                  <mat-slide-toggle
                    formControlName="isDefault"
                    [(ngModel)]="model.isDefault"
                  >
                    {{ "common.isActive" | translate }}</mat-slide-toggle
                  >
                </div>

                <!-- isSendSmsDescriptionRequired -->
                <div
                  class="checkbox-section sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4"
                >
                  <mat-slide-toggle
                    formControlName="isSendSmsDescriptionRequired"
                    [(ngModel)]="model.isSendSmsDescriptionRequired"
                  >
                    {{
                      fields + "isSendSmsDescriptionRequired" | translate
                    }}</mat-slide-toggle
                  >
                </div>

                <!-- isCanSeeContactsOfPublicPhonebooks -->
                <div
                  class="checkbox-section sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4"
                >
                  <mat-slide-toggle
                    formControlName="isCanSeeContactsOfPublicPhonebooks"
                    [(ngModel)]="model.isCanSeeContactsOfPublicPhonebooks"
                    [disabled]="isAdmin && !userSession?.isSuperAdmin()"
                  >
                    {{
                      fields + "isCanSeeContactsOfPublicPhonebooks" | translate
                    }}</mat-slide-toggle
                  >
                </div>

                <!-- isCanSeeContactsOfPrivatePhonebooks -->
                <div
                  class="checkbox-section sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4"
                >
                  <mat-slide-toggle
                    formControlName="isCanSeeContactsOfPrivatePhonebooks"
                    [(ngModel)]="model.isCanSeeContactsOfPrivatePhonebooks"
                    [disabled]="isAdmin && !userSession?.isSuperAdmin()"
                  >
                    {{
                      fields + "isCanSeeContactsOfPrivatePhonebooks" | translate
                    }}</mat-slide-toggle
                  >
                </div>

                <!-- isCanSendSmartWithoutConfirmation -->
                <div
                  class="checkbox-section sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4"
                >
                  <mat-slide-toggle
                    formControlName="isCanSendSmartWithoutConfirmation"
                    [(ngModel)]="model.isCanSendSmartWithoutConfirmation"
                  >
                    {{
                      fields + "isCanSendSmartWithoutConfirmation" | translate
                    }}</mat-slide-toggle
                  >
                </div>
              </div>
            </ng-container>
          </div>
        </fieldset>
      </section>

      <!-- role Information -->
      <section *ngIf="!input_isCurrentUser">
        <fieldset>
          <legend>
            {{ pageVocabs + "legends.roleInformation" | translate }}
          </legend>

          <div class="row">
            <role-selection-list
              [class.d-none]="!model.organizationId"
              type="organizationRoles"
              [id]="model.organizationId"
              searchLabel="messages.searchInRoles"
              [values]="model.roleIds"
              (values)="model.roleIds = $event"
            >
            </role-selection-list>

            <p
              [class.d-none]="model.organizationId"
              class="tw-text-gray-700 tw-text-lg tw-my-3 alert alert-primary tw-text-center"
            >
              {{ "messages.selectOrganizationForRoles" | translate }}
            </p>
          </div>
        </fieldset>
      </section>

      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="formPageConfig.isEditMode"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
  
</app-page-body>
